export default {
  titles: {
    default: 'Erinnerung an geplante Bestellung!',
    external_delivery: 'Fahrer zugewiesen!',
  },
  labels: {
    pickup: 'Abholung: {{time}}',
    serve: 'Servieren: {{time}}',
    preparation_time: 'Zubereitungszeit: {{time}} min',
  },
  buttons: {
    confirm: 'Vorbereiten',
    print_and_confirm: 'Drucken & Vorbereiten',
  },
  toasts: {
    something_went_wrong: 'Etwas ist schiefgelaufen, bitte versuche es erneut',
  },
};
